const InformacionNotFilledIcon = ({color}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0683 19.9998C4.54563 20.0376 0.0379353 15.5912 0.000128612 10.0685C-0.0376781 4.54576 4.40872 0.0380658 9.93144 0.000259057C15.4542 -0.0375477 19.9619 4.40885 19.9997 9.93157C20.0375 15.4543 15.5911 19.962 10.0683 19.9998ZM10.0547 17.9998C14.4728 17.9696 18.03 14.3634 17.9997 9.94526C17.9695 5.52709 14.3633 1.96997 9.94513 2.00021C5.52696 2.03046 1.96984 5.63661 2.00008 10.0548C2.03033 14.473 5.63648 18.0301 10.0547 17.9998ZM9.97251 6.00012C9.42024 6.0039 8.96947 5.55926 8.96569 5.00699C8.96191 4.45472 9.40655 4.00395 9.95882 4.00017C10.5111 3.99638 10.9619 4.44102 10.9656 4.9933C10.9694 5.54557 10.5248 5.99634 9.97251 6.00012ZM10.041 15.9999C9.4887 16.0037 9.03793 15.559 9.03415 15.0068L8.99307 9.00689C8.98929 8.45462 9.43393 8.00385 9.9862 8.00007C10.5385 7.99629 10.9892 8.44093 10.993 8.9932L11.0341 14.9931C11.0379 15.5453 10.5932 15.9961 10.041 15.9999Z"
        fill={color}
      />
    </svg>
  );
};

export default InformacionNotFilledIcon;
